import { icons } from './constant';

// ==============================|| LOCATION MENU ITEMS ||============================== //

const location = {
	id: 'location_masters',
	title: 'Location',
	type: 'collapse',
	icon: icons.IconLocation,
	children: [
		{
			id: 'states',
			title: 'States',
			type: 'item',
			url: '/states',
			icon: icons.MapOutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'branches',
			title: 'Branches',
			type: 'item',
			url: '/branches',
			icon: icons.IconBranch,
			breadcrumbs: true,
		},
		{
			id: 'pincodes',
			title: 'Pincodes',
			type: 'item',
			url: '/pincodes',
			icon: icons.IconPincode,
			breadcrumbs: true,
		},
	],
};

export default location;
